/* eslint-disable react/prop-types */
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { AiOutlinePrinter } from 'react-icons/ai';
import { toast } from 'react-hot-toast';

import { Container, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { FaCheck, FaEye, FaPlus, FaPrint } from 'react-icons/fa';
import api2 from '~/services/api2';
import DeleteItemOrders from '~/components/Orders/DeleteItemOrders';

import EyeModalOrders from '~/components/EyeModalOrders';
import PrintNewOrderComponent from '~/components/PrintNewOrderComponent';
import { useAuth } from '~/context/AuthContext';
import FooterNF from '~/components/FooterNF';
import PaymentFormDelivery from '~/components/Delivery/PaymentFormDelivery';

import { useMotoboys } from '~/context/MotoboysContext';
import { ActionButton, Button, DefaultSelect } from 'ui-kit-takeat';
import CreateMotoboy from '~/pages/Motoboys/Create';
import TableEditDelivery from '~/components/Operation/TablesOperation/TableEditDelivery';

import {
  Print,
  DisplayNoneImprimir,
  ModalPaymentBody,
  PrintOutline,
  ContainerOrders,
  Footer,
  ContentBody,
  Actions,
  InnerArea,
  DeliveryInfo,
  DeliveryTime,
  NameClient,
  PhoneClient,
  InfoClientDelivery,
} from './styles';

import {
  PhoneNumber,
  UserDeliveryInfo,
  CardBody,
  UserDeliveryInfoArea,
} from '../styles';

import { DeliveryCardHeader } from '../DeliveryCardHeader';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import { printHtmlInIframe } from '~/services/printer/printerUtils';
import PrintDeliveryButton from '~/components/Orders/Items/PrintDeliveryButton';
import ReactToPrint from 'react-to-print';
import { EveryOrdersDelivery } from '~/components/EveryOrdersDelivery';
import { format } from 'date-fns';
import { IconClipboardCheck } from 'takeat-design-system-ui-kit';

export default function OrderReadyDelivery({
  style,
  item,
  handleItemFinished,
  handleCancelItem,
  getAllOrders,
  handleUpdate,
  paymentMethods,
  allPaymentMethods,
  favoritePaymentMethods,
}) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [btnDisable, serBtnDisable] = useState(false);
  const [creatingMotoboy, setCreatingMotoboy] = useState(false);

  const { motoboys } = useMotoboys();
  const [paymentsState, setPaymentsState] = useState([]);
  const [applyDiscount, setApplyDiscount] = useState(!!item.discount_total);
  const [discount, setDiscount] = useState(item.discount_total || '');
  const [discountObs, setDiscountObs] = useState(item.discount_obs || '');
  const [discountObservation, setDiscountObservation] = useState(false);
  const [adminPassword, setAdminPassword] = useState(null);
  const [thisItemMotoboy, setThisItemMotoboy] = useState(item.motoboy);

  const [modalEye, setModalEye] = useState(false);
  function toggleEye() {
    setModalEye(!modalEye);
  }

  const [modalDelete, setModalDelete] = useState(false);
  const toggleDelete = () => setModalDelete(!modalDelete);

  const [modalDeleteDelivery, setModalDeleteDelivery] = useState(false);
  const toggleDeleteDelivery = () => {
    setModalDeleteDelivery(!modalDeleteDelivery);
    serBtnDisable(!btnDisable);
  };

  const [orders, setOrders] = useState([]);
  const getOrders = useCallback(async () => {
    try {
      const response = await api2.get(
        `/restaurants/basket-orders/${item.basket.id}`
      );
      setOrders(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [item]);

  const getPayments = useCallback(async () => {
    const response = await api2.get('restaurants/payments', {
      params: { table_session_id: item.session_id },
    });

    const parsedData = response.data.payments.map((data) => ({
      id: data.id,
      value: data.payment_value,
      payment_method_id: data.payment_method_id,
      removable: data.removable,
      label: data.label,
      keyword: data.payment_method.keyword,
    }));

    setPaymentsState(parsedData);
  }, [item.session_id]);

  useEffect(() => {
    if (modalDelete) {
      getOrders();
    }
  }, [modalDelete, getOrders]);

  const { user } = useAuth();

  async function printClick() {
    try {
      await api2.post('restaurants/printers/printer-queue', {
        order_basket_id: item.basket.id,
        order_type: 'new_order',
      });
      toast.success('Pedido impresso.');
    } catch (error) {
      toast.error('Erro ao imprimir pedido.');
    }
  }

  const userName = item?.buyer
    ? item.buyer.phone
      ? item.buyer.phone
      : item.buyer.ifood_phone
      ? item.buyer.ifood_phone
      : item.buyer.neemo_phone || ''
    : item?.waiter?.name;

  const handleUpdateMotoboy = async (data) => {
    if (data) {
      const id = data.id || data;
      try {
        await api2.post('/restaurants/motoboys/relate', {
          session_id: item.session_id,
          motoboy_id: id,
        });

        const updatedMotoboy = motoboys.find((m) => m.id === id);

        if (updatedMotoboy) {
          item.motoboy = updatedMotoboy;
          setThisItemMotoboy({
            value: updatedMotoboy.id,
            label: updatedMotoboy.name,
          });
        }

        toast.success('Motoboy atualizado com sucesso!');
      } catch (err) {
        console.log('Error handleUpdateMotoboy: ', err);
        toast.error('Erro ao atualizar motoboy');
      }
    } else {
      try {
        await api2.post('/restaurants/motoboys/relate', {
          session_id: item.session_id,
          motoboy_id: null,
        });

        setThisItemMotoboy({
          value: null,
          label: 'Retirar motoboy',
        });

        toast.success('Motoboy atualizado com sucesso!');
      } catch (err) {
        console.log('Error handleUpdateMotoboy: ', err);
        toast.error('Erro ao atualizar motoboy');
      }
    }
  };

  const handleDiscountUpdate = useCallback(async () => {
    if (item?.discount_total !== discount && discount > 0) {
      try {
        const response = await api2.put(
          `/restaurants/delivery/orders/update/${item?.session_id}`,
          {
            discount: applyDiscount ? parseFloat(discount) : null,
            discount_obs: applyDiscount
              ? discountObservation
                ? `${discountObs} - ${discountObservation}`
                : discountObs
              : null,
            user_id: user.user_id,
            password: adminPassword,
          }
        );

      } catch (err) {
        console.log('Error handleDiscountUpdate: ', err);
      }
    }
  }, [
    discount,
    discountObs,
    applyDiscount,
    adminPassword,
    discountObservation,
  ]);

  useEffect(() => {
    if (modalEye) {
      try {
        getPayments();
      } catch (error) {
        toast.error('Erro ao carregar informações');
      }
    }
  }, [getPayments, modalEye]);

  const browserZoomLevel = Math.round(window.devicePixelRatio * 100);

  const [loadingPrinter, setLoadingPrinter] = useState(false);

  async function printDeliverySession() {
    setLoadingPrinter(true);
    try {
      await api2.post('restaurants/printers/printer-queue', {
        table_session_id: item.session_id,
        is_delivery: true,
      });

      toast.success('Pedido enviado para impressão.');
    } catch (error) {
      toast.error('Erro ao imprimir pedido.');
    }
    setLoadingPrinter(false);
  }

  useEffect(() => {
    if (item.motoboy) {
      setThisItemMotoboy({ value: item.motoboy.id, label: item.motoboy.name });
    }
  }, [item]);

  const [motoboysOptions, setMotoboysOptions] = useState(false);

  useState(() => {
    const motoboysOld = {
      value: null,
      label: 'Retirar motoboy',
    };
    const newMotoboys = motoboys?.map((m) => {
      return {
        value: m.id,
        label: m.name,
      };
    });

    setMotoboysOptions([motoboysOld, ...newMotoboys]);
  }, []);

  const iframeRef = useRef(null);
  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      toast.error('Erro ao buscar dados para impressão');
    }
  };

  const componentRef = useRef(null);
  return (
    <>
      <DisplayNoneImprimir>
        <PrintNewOrderComponent
          restaurant={user}
          item={item}
          ref={componentRef}
          orders={orders}
        />
      </DisplayNoneImprimir>
      <iframe ref={iframeRef} style={{ display: 'none' }} />
      <ContentBody style={style}>
        <DeliveryCardHeader item={item} />
        <CardBody>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: 6,
              textAlign: 'left',
            }}
          >
            {item?.buyer?.name && <NameClient>{item.buyer.name}{item?.buyer?.has_observation && <span title="Há uma observação sobre este cliente" style={{ marginLeft: 4, display: 'inline-flex' }}><IconClipboardCheck fontSize={14} fill="#FFA814" /></span>}</NameClient>}
            {item?.basket?.schedule && (
              <PhoneClient>
                <strong>{item?.basket?.schedule}</strong>
              </PhoneClient>
            )}
            <PhoneClient>{userName}</PhoneClient>
            {!item?.with_withdrawal && (
              <UserDeliveryInfoArea>
                {item?.buyer?.delivery_address?.neighborhood && (
                  <InfoClientDelivery>
                    Bairro: {item?.buyer?.delivery_address?.neighborhood}-{' '}
                    {item?.buyer?.delivery_address?.city}
                  </InfoClientDelivery>
                )}

                {item?.buyer?.delivery_address?.zip_code && (
                  <InfoClientDelivery>
                    CEP: {item?.buyer?.delivery_address?.zip_code}
                  </InfoClientDelivery>
                )}
              </UserDeliveryInfoArea>
            )}
            {item?.motoboy?.name && (
              <UserDeliveryInfo>
                <strong>Motoboy:</strong> {item?.motoboy?.name}
              </UserDeliveryInfo>
            )}

            {item?.ifood_delivery_time && (
              <DeliveryInfo>
                <span>Previsão de entrega:</span>{' '}
                <DeliveryTime>
                  {format(new Date(item.ifood_delivery_time), "HH'h'mm")}
                </DeliveryTime>
              </DeliveryInfo>
            )}
          </div>
          <Actions>
            <FaCheck color="#3BD2C1" size={18} onClick={toggleEye} />
            <FaEye color="#FFA814" size={20} onClick={toggle} />
            <TableEditDelivery
              item={item}
              toggleDeleteDelivery={toggleDeleteDelivery}
              handleUpdate={handleUpdate}
              orderReady
            />
          </Actions>
        </CardBody>

        <Modal isOpen={modal} toggle={toggle}>
          <ModalBody>
            <ContainerOrders browserZoomLevel={browserZoomLevel}>
              <EyeModalOrders item={item} />
            </ContainerOrders>
          </ModalBody>
          <Footer
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: 20,
            }}
          >
            {item?.table.table_type === 'delivery' ? (
              <PrintDeliveryButton
                item={item}
                user={user}
                printClick={printClick}
                printDeliverySession={printDeliverySession}
                loadingPrinter={loadingPrinter}
                handleFetchDataToPrint={handleFetchDataToPrint}
                fetchDataPayload={{
                  print_type: 'table_session',
                  table_session_id: item.session_id,
                  is_delivery: true,
                }}
              />
            ) : (
              <Print onClick={printClick}>
                <AiOutlinePrinter color="black" size={20} />
              </Print>
            )}
          </Footer>
        </Modal>

        <Modal isOpen={modalDeleteDelivery} toggle={toggleDeleteDelivery}>
          <ModalBody>
            <Container>
              <h3>Tem certeza que deseja recusar o pedido?</h3>
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button
              inverted
              onClick={() => toggleDeleteDelivery()}
              title="Desistir"
            />
            <Button
              onClick={() =>
                handleCancelItem({
                  from: 'accepted',
                  order_basket_id: item.basket.id,
                  session_id: item.session_id,
                  ifood_id: item.basket.ifood_id,
                })
              }
              title=" Recusar o pedido"
            />
          </ModalFooter>
        </Modal>

        <Modal isOpen={modalDelete} toggle={toggleDelete}>
          <ModalBody>
            <Container>
              <DeleteItemOrders
                item={item}
                modalDelete={modalDelete}
                from="accepted"
                orders={orders}
              />
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button
              title="Cancelar esse(s) item(s)"
              onClick={() =>
                handleCancelItem({
                  order_basket_id: item.basket.id,
                  from: 'accepted',
                })
              }
            />
          </ModalFooter>
        </Modal>

        <Modal isOpen={modalEye} toggle={toggleEye}>
          <InnerArea browserZoomLevel={browserZoomLevel}>
            <ModalPaymentBody>
              <PaymentFormDelivery
                item={item}
                payments_session={paymentsState}
                // getPayments={getPayments}
                setPaymentsState={setPaymentsState}
                discount={discount}
                discountObs={discountObs}
                setDiscount={setDiscount}
                setDiscountObs={setDiscountObs}
                setDiscountObservation={setDiscountObservation}
                applyDiscount={applyDiscount}
                setApplyDiscount={setApplyDiscount}
                adminPassword={adminPassword}
                setAdminPassword={setAdminPassword}
                paymentMethods={paymentMethods}
                allPaymentMethods={allPaymentMethods}
                favoritePaymentMethods={favoritePaymentMethods}
              />
            </ModalPaymentBody>

            {motoboysOptions &&
              motoboysOptions.length > 0 &&
              !item.ifood_on_demand_id && (
                <div
                  style={{
                    marginTop: '20px',
                    marginRight: '10px',
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '15px',
                  }}
                >
                  <DefaultSelect
                    options={motoboysOptions}
                    placeholder="Motoboy"
                    name="motoboy"
                    label="Motoboy"
                    value={thisItemMotoboy}
                    onChange={(e) => handleUpdateMotoboy(e.value)}
                  />
                  <ActionButton
                    buttonColor="#2ec9b7"
                    icon={<FaPlus />}
                    minWidth={40}
                    onClick={() => setCreatingMotoboy(true)}
                  />
                </div>
              )}

            <Modal isOpen={creatingMotoboy}>
              <CreateMotoboy
                toggleModalRegisterMotoboy={() => setCreatingMotoboy(false)}
                motoboyCreated={(data) => {
                  console.log('motoboy created data > ', data);
                  handleUpdateMotoboy(data);
                  setThisItemMotoboy({ value: data.id, label: data.name });
                  setCreatingMotoboy(false);
                }}
              />
            </Modal>

            <FooterNF
              session={item}
              toggleEye={toggleEye}
              getSessions={getAllOrders}
              payments={paymentsState}
              has_nfce={user.has_nfce}
              item={item}
              handleItemFinished={handleItemFinished}
              motoboys={motoboys}
              handleDiscountUpdate={handleDiscountUpdate}
              discount={discount}
              discountObs={discountObs}
              applyDiscount={applyDiscount}
              adminPassword={adminPassword}
              user={user}
            />
          </InnerArea>
        </Modal>
      </ContentBody>
    </>
  );
}